<span>{{message}}</span>
@if (availableApps) {
  <ul>
    @for (app of availableApps; track app) {
      <li><a id="{{app.webAppName}}" (click)="navigateToApp(app)" >{{app.webAppTitle}}</a></li>
    }
  </ul>
}